
import React from "react";
import { Link } from "react-router-dom";
import { FaGithub, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      
      <div className="scroll">
        <a href="#top"><i className="fa fa-angle-up"></i></a>
      </div>
      <div className="social-icons">
        <a href="https://github.com"><FaGithub className="icon github" /></a>
        <a href="https://linkedin.com"><FaLinkedin/></a>
        <a href="https://www.instagram.com/jny_labs/"><FaInstagram/></a>
        <Link to="./Blogs">Blogs</Link>
        <Link to="./Addblog">AddBlogs</Link>
       

      </div>
      <p>&copy; 2023 JNY Labs. All Rights Reserved.</p>
    </div>
  );
}

export default Footer;

